<ion-header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.guest_list' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'guest_home'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" color="light" #content>
  <ion-refresher class="background-light" slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content class="background-light"
      pullingIcon="chevron-down-circle-outline"
      pullingText=""
      refreshingSpinner="circles"
      refreshingText="">
    </ion-refresher-content>
  </ion-refresher>

  <div class="content-div">
    <div class="ion-padding-bottom">
      <swiper-container class="setting-swiper ion-padding-vertical" [slidesPerView]="settingFieldSlidePerView">
        <swiper-slide>
          <ion-item class="background-transparent ion-item-no-padding" lines="none">
            <ion-label class="ion-text-wrap ion-no-margin">
              <div class="vertical-center">
                <ion-img class="icon-img center vertical-center" src="./assets/wedding/img/guest/invited-by.webp" (click)="presentGuestStatisticModal('invitedBy')"></ion-img>
              </div>
              <div class="margin-top-6 ion-text-center vertical-center">
                <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentGuestStatisticModal('invitedBy')">{{ 'GUEST.lbl.invited_by' | translate }}</ion-text>
              </div>
            </ion-label>
          </ion-item>
        </swiper-slide>
        <swiper-slide>
          <ion-item class="background-transparent ion-item-no-padding" lines="none">
            <ion-label class="ion-text-center ion-no-margin">
              <div class="vertical-center">
                <ion-img class="icon-img center vertical-center" src="./assets/wedding/img/guest/category.webp" (click)="presentGuestStatisticModal('category')"></ion-img>
              </div>
              <div class="margin-top-6 ion-text-center vertical-center">
                <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentGuestStatisticModal('category')">{{ 'LBL.category' | translate }}</ion-text>
              </div>
            </ion-label>
          </ion-item>
        </swiper-slide>
        <swiper-slide>
          <ion-item class="background-transparent ion-item-no-padding" lines="none">
            <ion-label class="ion-text-center ion-no-margin">
              <div class="vertical-center">
                <ion-img class="icon-img center vertical-center" (click)="presentGuestStatisticModal('dietaryReq')" src="./assets/wedding/img/guest/dietary-req.webp"></ion-img>
              </div>
              <div class="margin-top-6 ion-text-center vertical-center">
                <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentGuestStatisticModal('dietaryReq')">{{ 'GUEST.lbl.dietary_req' | translate }}</ion-text>
              </div>
            </ion-label>
          </ion-item>
        </swiper-slide>
        <swiper-slide>
          <ion-item class="background-transparent ion-item-no-padding" lines="none">
            <ion-label class="ion-text-center ion-no-margin">
              <div class="vertical-center">
                <ion-img class="icon-img center vertical-center" (click)="presentGuestStatisticModal('specialReq')" src="./assets/wedding/img/guest/special-req.webp"></ion-img>
              </div>
              <div class="margin-top-6 ion-text-center vertical-center">
                <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentGuestStatisticModal('specialReq')">{{ 'GUEST.lbl.special_req' | translate }}</ion-text>
              </div>
            </ion-label>
          </ion-item>
        </swiper-slide>
        <swiper-slide>
          <ion-item class="background-transparent ion-item-no-padding" lines="none">
            <ion-label class="ion-text-center ion-no-margin">
              <div class="vertical-center">
                <ion-img class="icon-img center vertical-center" (click)="presentGuestStatisticModal('session')" src="./assets/wedding/img/guest/session.webp"></ion-img>
              </div>
              <div class="margin-top-6 ion-text-center vertical-center">
                <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentGuestStatisticModal('session')">{{ 'LBL.session' | translate }}</ion-text>
              </div>
            </ion-label>
          </ion-item>
        </swiper-slide>
      </swiper-container>
    </div>
    
    <div>
      <div class="seg-div" *ngIf="invitedByList?.length > 1">
        <ion-segment [(ngModel)]="invitedBy" scrollable>
          <ion-segment-button [value]="''">
            <ion-text>
              <div>{{'LBL.all' | translate }}</div>
            </ion-text>
          </ion-segment-button>
          <ng-container *ngIf="invitedByList">
            <ion-segment-button [value]="invited" *ngFor="let invited of invitedByList">
              <ion-text>
                <ng-container *ngIf="invited.custom">{{ invited.value }}</ng-container>
                <ng-container *ngIf="!invited.custom">
                  {{ 'LIST.invited_by.' + invited.value | translate }}
                </ng-container>
              </ion-text>
            </ion-segment-button>
          </ng-container>
        </ion-segment>
      </div>
  
      <swiper-container [slidesPerView]="statisticSlidePerView">
        <swiper-slide>
          <app-guest-statistic-item class="full-width slide-item" [reset]="reset" [status]="{ attending: 'attending' }" [setAttendingType]="'attending'" [setInvitedBy]="invitedBy" [name]="'LIST.attending_status.attending' | translate" [statisticType]="'attending'" [all]="true" [cardType]="'square'" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide>
          <app-guest-statistic-item class="full-width slide-item" [reset]="reset" [status]="{ attending: 'pending' }" [setAttendingType]="'pending'" [setInvitedBy]="invitedBy" [name]="'LIST.attending_status.pending' | translate" [statisticType]="'attending'" [all]="true" [cardType]="'square'" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide>
          <app-guest-statistic-item class="full-width slide-item" [reset]="reset" [status]="{ attending: 'not_attending' }" [setAttendingType]="'not_attending'" [setInvitedBy]="invitedBy" [name]="'LIST.attending_status.not_attending' | translate" [statisticType]="'attending'" [all]="true" [cardType]="'square'" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide>
          <app-guest-statistic-item class="full-width slide-item" [reset]="reset" [name]="'LIST.group.group' | translate" [statisticType]="'group'" [all]="true" [cardType]="'square'" [setGroupType]="'group'" [setInvitedBy]="invitedBy" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide>
          <app-guest-statistic-item class="full-width slide-item" [reset]="reset" [name]="'LIST.group.individual' | translate" [statisticType]="'group'" [all]="true" [cardType]="'square'" [setGroupType]="'individual'" [setInvitedBy]="invitedBy" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
      </swiper-container>
  
      <div class="ion-padding-vertical">
        <ion-grid class="ion-no-padding" fixed>
          <ion-row>
            <ion-col>
              <app-guest-statistic-item class="full-width" [reset]="reset" [seating]="'assigned'" [setSeatingType]="'assigned'" [setInvitedBy]="invitedBy" [name]="'LIST.assign_status.assigned_seating' | translate" [statisticType]="'seating'" [all]="true" [cardType]="'rect'" [color]="'tertiary'" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
            <ion-col>
              <app-guest-statistic-item class="full-width" [reset]="reset" [status]="{ qrcode: true }" [setQrcodeType]="'sent'" [setInvitedBy]="invitedBy" [name]="'LIST.send_status.sent_qrcode' | translate" [statisticType]="'qrcode'" [all]="true" [cardType]="'rect'" [color]="'tertiary'" [showPercent]="true" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-guest-statistic-item class="full-width" [reset]="reset" [seating]="'not_assign'" [setSeatingType]="'not_assign'" [setInvitedBy]="invitedBy" [name]="'LIST.assign_status.not_yet_assign' | translate" [statisticType]="'seating'" [all]="true" [cardType]="'rect'" [color]="'grey'" [showNumber]="true" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
            <ion-col>
              <app-guest-statistic-item class="full-width" [reset]="reset" [status]="{ qrcode: false }" [setQrcodeType]="'not_send'" [setInvitedBy]="invitedBy" [name]="'LIST.send_status.not_yet_send' | translate" [statisticType]="'qrcode'" [all]="true" [cardType]="'rect'" [color]="'grey'" [showPercent]="true" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</ion-content>
